import React from "react";
import { auth } from "../firebase"; // Import Firebase Auth
import { signOut } from "firebase/auth"; // Import signOut method
import { useNavigate } from "react-router-dom";

function Header() {
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth); // Firebase sign out
      navigate("/login"); // Redirect to login after logout
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };


  return (
    <header className="flex justify-between items-center bg-white shadow-md p-4">
      {/* Company Logo */}
      <div className="flex items-center">
        <img src="/ev-logo.png" alt="Company Logo" className="h-11" />
      </div>

     {/* Logout Button */}
      <button
        onClick={handleLogout}
        className="bg-neutral-900 text-white px-3 py-1 rounded hover:bg-gray-700"
      >
        Logout
      </button>
    </header>
  );
}

export default Header;
